import React from 'react';
import clsx from 'clsx';
import { ctaPurpleRight } from '../../../../../../../assets/hostedassets';
import profileStyles from './UserProfile.module.scss';
import tabStyles from '../../../../ManagementProfileTab/ManagementProfileTab.module.scss';
import type { CreditBureauRowProps } from './ManagementUserProfile.types';
import { hasValidCreditScore } from './managementUserProfileUtils';
import DrawerRow from './DrawerRow';
import ClickableValue from './ClickableValue';
import { NotConfiguredLabel } from '../../../../ManagementProfileTab/CheckStatusLabels';
import { DRAWER_ROW_LABELS, NOT_CONFIGURED_TOOLTIP } from '../../../../ManagementProfileTab/ManagementProfileTabConstants';

const CreditBureauRow = ({ score, onClick, isPDFReport, notConfigured }: CreditBureauRowProps) => {
    // Not Configured wins over a stored score, as the Credit Bureau tab drops excluded designations.
    if (notConfigured) {
        return (
            <DrawerRow
                label={DRAWER_ROW_LABELS.CREDIT_BUREAU}
                valueOwnsStyling
                title={NOT_CONFIGURED_TOOLTIP}
                value={<NotConfiguredLabel />}
            />
        );
    }
    const clickable = hasValidCreditScore(score) && !isPDFReport && !!onClick;
    return (
        <DrawerRow
            label={DRAWER_ROW_LABELS.CREDIT_BUREAU}
            valueOwnsStyling
            value={
                hasValidCreditScore(score) ? (
                    <ClickableValue
                        clickable={clickable}
                        onClick={onClick}
                        className={clsx(profileStyles.CountValue, { [tabStyles.creditClickable]: clickable })}
                    >
                        <span className={tabStyles.creditScore}>
                            {/* ctaPurpleRight is a go-here arrow, so it only earns its place when the
                                row actually navigates. Inside this branch hasValidCreditScore is already
                                true, so on desktop `clickable` reduces to !isPDFReport — the previous
                                condition — and nothing changes there. RECUR-27903. */}
                            {clickable && <img src={ctaPurpleRight} alt={''} className={profileStyles.CountIcon} />}
                            {score}
                        </span>
                    </ClickableValue>
                ) : undefined
            }
        />
    );
};

export default CreditBureauRow;
